(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_typeDetailController', Campagna_typeDetailController);

    Campagna_typeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campagna_type'];

    function Campagna_typeDetailController($scope, $rootScope, $stateParams, previousState, entity, Campagna_type) {
        var vm = this;

        vm.campagna_type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagna_typeUpdate', function(event, result) {
            vm.campagna_type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
